import PropTypes from "prop-types";
import React from "react";
import { isRequestedStaff } from "../../../utils/requestedStaff";

const RequestedStaffChoice = ({ requested, onChange, children, staffCount, t = (value) => value }) => {
  const selected = isRequestedStaff(requested);
  if (Number(staffCount) === 1) return <>{children}</>;
  return (
    <>
      <fieldset className="mb-3">
        <legend className="form-label fs-6">{t("Did the client request a staff member?")}</legend>
        <label className="me-3">
          <input type="radio" name="requested-staff-choice" checked={selected} onChange={() => onChange(true)} /> {t("Yes")}
        </label>
        <label>
          <input type="radio" name="requested-staff-choice" checked={!selected} onChange={() => onChange(false)} /> {t("No")}
        </label>
      </fieldset>
      {selected && (
        <div className="form-label">
          {t("Requested Staff")} <i className="far fa-eye" aria-label="Requested staff indicator" />
        </div>
      )}
      {children}
    </>
  );
};

RequestedStaffChoice.propTypes = {
  requested: PropTypes.bool,
  onChange: PropTypes.func,
  children: PropTypes.node,
  staffCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  t: PropTypes.func,
};

export default RequestedStaffChoice;
